module.exports = __webpack_public_path__ + "static/media/34.b0f1adf1.wav";